// Client-side campaign helpers — thin wrappers around the backend giveaway
// endpoints. All calls are anonymous (X-Device-Id is injected by lib/api.js)
// and failure is always swallowed — the campaign must never block a real UX
// flow. Privacy: nothing on this file ever sends coordinates or notes.

import { api } from "./api";

const KEY_INSTALL_REPORTED = "spotdrop_campaign_install_reported";

/** Idempotent: record a save-car campaign event. Backend enforces 1/day/device. */
export function reportSaveCarEvent() {
  api.post("/campaign/events/save_car").catch(() => {});
  api.post("/activation/save_car").catch(() => {});
}

/** Called from the `appinstalled` event listener. Backend enforces once-per-device
 *  via a unique index; we also gate client-side to avoid a stampede on reload. */
export function reportInstallEvent() {
  try {
    if (localStorage.getItem(KEY_INSTALL_REPORTED) === "1") return;
    localStorage.setItem(KEY_INSTALL_REPORTED, "1");
  } catch {
    /* ignore */
  }
  api.post("/campaign/events/install").catch(() => {
    // Never rollback the local flag; the DB unique index is the real guard.
  });
}

/** Fetch the current device's entry breakdown + participant profile. */
export async function fetchCampaignEntries() {
  try {
    const res = await api.get("/campaign/entries");
    return res.data || null;
  } catch {
    return null;
  }
}

/** Fetch the public campaign meta (active/name/prize/etc). */
export async function fetchPublicCampaign() {
  try {
    const res = await api.get("/campaign/public");
    return res.data || { active: false };
  } catch {
    return { active: false };
  }
}

/** Register (or update) this device's participant contact. */
export async function joinCampaign({ email, instagram }) {
  const res = await api.post("/campaign/join", {
    email: email || null,
    instagram: instagram || null,
  });
  return res.data;
}
